import type { PropsWithChildren, JSX } from 'react';
import type { Path, PathValue } from 'react-hook-form';

export type CheckboxOption = {
  id: string | boolean;
  label: string;
  description?: string | JSX.Element;
  disabled?: boolean;
};

export enum CheckboxVariant {
  LEFT = 'left',
  RIGHT = 'right',
}
export enum CheckboxVerticalVariant {
  START = 'start',
  CENTER = 'center',
}

export type CheckboxGroupProps = {
  heading?: string;
  options: CheckboxOption[];
  checked: (string | boolean)[];
  variant?: CheckboxVariant;
  disabled?: boolean;
  required?: boolean;
  showHeading?: boolean;
  hasError?: boolean;
  onChange: (val: string | boolean) => void;
};

export type CheckboxProps = {
  name: string;
  checked: boolean;
  variant?: CheckboxVariant;
  verticalVariant?: CheckboxVerticalVariant;
  required?: boolean;
  hasError?: boolean;
  onChange: () => void;
} & Omit<CheckboxOption, 'id'>;

export type SingularCheckboxProps<T> = PropsWithChildren<
  {
    name: Path<T>;
    label?: string;
    defaultValue?: PathValue<T, Path<T>>;
    required?: boolean;
    variant?: CheckboxVariant;
    verticalVariant?: CheckboxVerticalVariant;
    description?: string;
    analyticsEventName?: string;
  } & Omit<CheckboxOption, 'id'>
>;
